import React, { useEffect } from 'react';
import PolicyLayout from '../components/common/PolicyLayout/PolicyLayout';

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = 'NEST | Privacy Policy';
  }, []);
  return (
    <PolicyLayout title="Privacy Policy" breadcrumbs={['Privacy Policy']}>
      <h1>Privacy Policy</h1>

      <h2>Governing Laws</h2>
      <p>
        This website is operated by <strong>Nest Auto Transport</strong> from its offices in the United States.
        We make no representation that the content or services provided on this site are suitable or available for
        use in other regions. Accessing the site from areas where its content may be illegal is strictly prohibited.
        Users who choose to access the site from outside the U.S. are solely responsible for compliance with their
        local laws.
      </p>
      <p>
        All matters related to your access or use of the site are governed by
        <strong>U.S. federal laws</strong> and applicable state laws. Any legal proceedings arising from your use of
        this site shall be brought exclusively in the state or federal courts of the United States. By using this
        site, you agree to submit to the jurisdiction of these courts.
      </p>

      <h2>User Accounts, Passwords, and Security</h2>
      <p>
        Certain features of this site may require you to create an account. When registering, you must provide
        accurate, complete, and up-to-date information. You are solely responsible for maintaining the confidentiality
        of your username and password, as well as all activities that occur under your account.
      </p>
      <p>
        You agree to notify <strong>Nest Auto Transport</strong> immediately of any unauthorized use of your account
        or security breach. We are not responsible for any loss or damage resulting from unauthorized access. However,
        you may be held liable for losses incurred by <strong>Nest Auto Transport</strong> or others due to misuse of
        your credentials.
      </p>

      <h2>Use of Materials on This Website</h2>

      <h3>Nest Auto Transport Content</h3>
      <p>
        All materials and information available on this site are the intellectual property of
        <strong>Nest Auto Transport</strong>. You may not copy, modify, distribute, publish, or create derivative
        works from any content on this site without prior written consent.
      </p>

      <h3>User-Generated Content</h3>
      <p>
        By submitting or uploading any content, you acknowledge full responsibility for its accuracy, legality, and
        originality. You agree not to upload content that is false, offensive, illegal, or infringes on third-party
        rights. You also grant <strong>Nest Auto Transport</strong> a non-exclusive, royalty-free, perpetual, and
        worldwide license to use, reproduce, adapt, publish, and distribute your submitted content in accordance with
        our Privacy Policy.
      </p>

      <h2>Access to Your Personal Information</h2>
      <p>
        If you are not a registered user, we do not store or have access to any personal information about you. For
        registered clients, authorized <strong>system administrators</strong> and <strong>support staff</strong> may
        access your account data solely for maintenance and assistance purposes.
      </p>

      <h2>Data Retention Policy</h2>
      <p>
        Information submitted through forms (like contact or quote requests) is retained until you request its
        deletion. We use this data to enhance your experience and recognize returning users.
      </p>

      <h2>Collection and Use of Mobile Numbers</h2>
      <p>
        When you provide your mobile number, we may use it for account-related notifications, shipment updates, and
        promotional messages (only if you opt-in). Your number is never sold or shared with marketers. To comply with
        telecommunications regulations, it may be registered with
        <strong>The Campaign Registry (TCR)</strong> and our SMS provider <strong>RingCentral</strong>.
      </p>

      <h2>Data Security</h2>
      <p>
        We take the protection of your personal data seriously. All information, including mobile numbers, is
        safeguarded under strict security protocols. Data shared with third parties (like TCR, Vonage, or RingCentral)
        is solely for compliance and technical delivery.
      </p>

      <h2>Privacy Assurance: No Sharing of Mobile Data for Marketing</h2>
      <p>
        <strong>Nest Auto Transport</strong> does not share or sell mobile information for marketing or promotional
        purposes. Data collected is used only for service-related notifications.
      </p>

      <h2>Security Practices</h2>
      <p>
        Our site uses <strong>SSL/HTTPS encryption</strong> to protect all user communications. In case of a data
        breach, we will act promptly to restore security, notify affected users, and reset credentials as needed.
      </p>
    </PolicyLayout>
  );
};

export default PrivacyPolicy;


